import useProfileCommonStore from '../use-profile-common-store';
import { ASSET_CLASSES } from '../get-asset-class';
import { useEffect, useState } from 'react';
import { useProfileGeographicDistribution } from '../../../hooks/api';

import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import { FUND_TYPES } from '../get-fund-type';

const GEOGRAPHIES = [
  { label: 'Region', value: 'region' },
  { label: 'Country', value: 'country' }
];

const hasCountryData = source => !!get(source, 'data.countryAllocation', []).length;
const hasRegionData = source => !!get(source, 'data.regionAllocation', []).length;
const shouldShowToggle = source => hasCountryData(source) && hasRegionData(source);

const checkGeography = (source, setState) => {
  if (source.isLoaded) {
    if (!hasRegionData(source)) setState(GEOGRAPHIES[1]);
  }
};
const getTableData = (source, geography) => {
  const allocation = get(source, `data[${geography}Allocation]`, []);
  return allocation.length ? orderBy(allocation.filter(Boolean), ['allocationPercent'], ['desc']) : [{ allocationPercent: 0,
    country: '--' }];
};

const useGeographicDistribution = (isTopFiveCountries = false) => {
  const { apiConfigBase, commonState } = useProfileCommonStore();
  const geographicDistribution = useProfileGeographicDistribution(apiConfigBase);
  const [geography, setGeography] = useState(isTopFiveCountries ? GEOGRAPHIES[1] : GEOGRAPHIES[0]);
  const isATA = get(commonState, 'fundType', '') === FUND_TYPES.afterTaxAnnuity;

  useEffect(() => {
    if (!isATA) {
      checkGeography(geographicDistribution, setGeography);
    }
  }, [geographicDistribution, isATA]);

  const asOfDate = get(geographicDistribution, 'data.asOfDate', null);
  const isRealEstate = get(commonState, 'assetClass', '') === ASSET_CLASSES.realEstate;
  const tableData = getTableData(geographicDistribution, geography.value);
  const ticker = get(commonState, 'xref.data.symbol');
  const hideForATA = isATA && get(geographicDistribution, 'data.regionAllocation', []).length === 0;
  const hideTopFiveCountries = !hasCountryData(geographicDistribution);
  const isOneRegion100 = isATA && !isTopFiveCountries && tableData.find(data => data.allocationPercent === 100);
  const renderGeographicDistribution = geographicDistribution.isLoaded ? get(geographicDistribution, `data[${geography.value}Allocation]`, [])?.some(item => item['allocationPercent'] !== 0) : true;

  return {
    asOfDate,
    geographies: GEOGRAPHIES,
    geographySelected: geography,
    hideForATA,
    hideTopFiveCountries,
    onChangeGeography: setGeography,
    regionSelected: geography.value === 'region',
    renderDots: geography.value === 'region' && !isRealEstate,
    renderGeographicDistribution,
    showMap: !isRealEstate,
    showToggle: shouldShowToggle(geographicDistribution),
    tableData: isOneRegion100 ? tableData.filter(x => {
      return x.allocationPercent === 100;
    }) : tableData,
    tableDataLabel: isRealEstate
      ? '% of Real Estate Investments'
      : '% of Net Assets',
    ticker
  };
};

export default useGeographicDistribution;
